import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tooltip container right" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row flex-1" }
const _hoisted_7 = { class: "row flex-1" }

import TextBase from '@/design-system/atoms/TextBase.vue'
type Props = {
  label: string
  color?: string
  value: string
  x: number
  y: number
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ChartTooltip',
  props: {
    label: {},
    color: {},
    value: {},
    x: {},
    y: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "be424e04": (_ctx.y + "px"),
  "38fdac1f": (_ctx.x + "px")
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "arrow" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "color",
            style: _normalizeStyle({ backgroundColor: _ctx.color })
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(TextBase, {
              class: "label",
              text: _ctx.label,
              color: "secondary",
              weight: "bold",
              type: "tiny"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(TextBase, {
              class: "value",
              text: _ctx.value,
              type: "label",
              weight: "bold"
            }, null, 8, ["text"])
          ])
        ])
      ])
    ])
  ]))
}
}

})